import React, { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const AddPricingTooltip: FC = ({ children }) => (
  <Tooltip title="Add resourcing details to matter to get suggested price" placement="left">
    <InfoCircleOutlined style={{ marginRight: 5 }} />
    {children}
  </Tooltip>
);
